import Sprite = PIXI.Sprite;
import Container = PIXI.Container;
import { createSprite } from '../../utils/GameEngine';
import { Avatar } from '../../UI/elements/Avatar';

export class ProgressBar extends Container {
    constructor(private progress: number) {
        super();
        this.drawLayout();
    }

    private drawLayout(): void {
        const background: Sprite = createSprite('stamina_bar', this);
        const edge: Sprite = createSprite('stamina_bar_fill_end', this);
        edge.scale.x = -1;
        edge.anchor.set(0, 0.5);
        edge.position.set(19, background.height / 2);

        const bar: Sprite = createSprite('stamina_bar_fill', this);
        bar.anchor.set(0, 0.5);
        bar.scale.x = 0;
        bar.position.set(edge.x - 1, background.height / 2);

        const avatar: Avatar = new Avatar(null, true);
        this.addChild(avatar);
        avatar.scale.set(0.5, 0.5);
        avatar.position.set(bar.width + bar.x - avatar.width / 2, background.height / 2 - avatar.height / 2 + 10);

        const newScale: number = this.progress / 100;
        TweenLite.to(
            bar.scale,
            1,
            {
                x: newScale,
                onUpdate: (): void => {
                    avatar.position.set(bar.width + bar.x - avatar.width / 2, background.height / 2 - avatar.height / 2 + 10);
                },
                ease: Back.easeOut
            }
        );
    }
}
